import {ReactNode, useContext} from 'react'
import {Button, theme, Typography} from "antd";
import {LeftOutlined} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import styled from "styled-components";
import {ButtonType} from "antd/es/button";
import {useSubscriptionEndDate} from "../hooks/useSubscriptionEndDate.ts";
import {AuthContext} from "client/src/context/AuthContext.tsx";
import {PromoAlert} from "./PromoAlert.tsx";

const {useToken} = theme;
const {Title} = Typography;

interface IPageTitle {
    children?: ReactNode
    onMainBtnClick?: () => void
    mainBtnText?: string
    title?: string
    description?: string
    mainBtnType?: ButtonType
    isLoading?: boolean
}

export const PageTitle = ({children, onMainBtnClick, mainBtnText, title, description, mainBtnType, isLoading}: IPageTitle) => {
    const navigate = useNavigate()
    const {token} = useToken();
    const location = useLocation();
    const {user} = useContext(AuthContext);

    const isClient = !!(user?.client_id && user.client_id > 0);

    const {endDate} = useSubscriptionEndDate(!isClient && !!user);

    const isAiPage = ['/ai-jobs', '/cv-generator', '/cover-letter', '/interview', '/job-coach', '/rentensteuerberater', '/silverplus/subscription']
        .some(path => location.pathname.startsWith(path));

    const hasActiveSubscription = !isClient && endDate && !isNaN(endDate.getTime()) && endDate > new Date();

    const shouldShowAlert = !isAiPage && !hasActiveSubscription && !isClient;

    return <div>
        {shouldShowAlert && <PromoAlert/>}
        <TitleWrapper>
            <BtnWrapper>
                <Button shape="circle" size="large" onClick={() => navigate(-1)} icon={<LeftOutlined/>}/>
                {title ? <div>
                        <Title style={{fontSize: token.fontSizeHeading3, marginBottom: 0}}>{title}</Title>
                        {description && <p style={{margin: 0, maxWidth: 600}}>{description}</p>}
                    </div> :
                    children}
            </BtnWrapper>
            {mainBtnText && <BtnStyled type={mainBtnType || "primary"} loading={isLoading} disabled={!!isLoading}
                                       onClick={onMainBtnClick} onTouchStart={onMainBtnClick}>{mainBtnText}</BtnStyled>}
        </TitleWrapper>
    </div>
}

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const BtnWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
`;

const BtnStyled = styled(Button)`
    width: 300px;
    border-radius: 30px;
    @media (max-width: 767px) {
        width: 100%;
    }
`;
